import React, { useState, Fragment, useContext, useEffect } from "react";
import "../global/pages.css";
import "./Done.css";
import Label from "../atoms/Label";
import CheckIcon from "../atoms/CheckIcon";
import { server, files } from "../configs";
import { Context } from "../GlobalContext";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

const Done = ({ history, location }) => {
  const [coupon, setCoupon] = useState({});
  const [phoneNumber, setPhoneNumber] = useState("");
  const [doneState, setDoneState] = useState("");
  const [feedbackText, setFeedbackText] = useState("");
  const { userData, setUserData, token } = useContext(Context);

  const couponList = userData.gov.giftList;

  const isValidPhone = (value) => {
    const digits = value.replace(/[^0-9]/g, "");
    // 010/011/016/017/018/019 + 7~8자리 (총 10~11자리)
    return /^01[016789]\d{7,8}$/.test(digits);
  };

  const inputPhoneNumber = (value) => {
    var number = value.replace(/[^0-9]/g, "");
    var phone = "";

    if (number.length < 4) {
      setPhoneNumber(number);
      return;
    } else if (number.length < 7) {
      phone += number.substr(0, 3);
      phone += "-";
      phone += number.substr(3);
    } else if (number.length < 11) {
      phone += number.substr(0, 3);
      phone += "-";
      phone += number.substr(3, 3);
      phone += "-";
      phone += number.substr(6);
    } else if (number.length === 11) {
      phone += number.substr(0, 3);
      phone += "-";
      phone += number.substr(3, 4);
      phone += "-";
      phone += number.substr(7);
    } else {
      return;
    }

    setPhoneNumber(phone);
  };

  const patchCoupon = () => {
    const jwt = localStorage.getItem("jwt");
    const content = {
      giftContact: phoneNumber,
      giftOption:
        doneState === "기부" ? "DONATE" : doneState === "신청" ? "GET" : "NONE",
      gift: `${coupon.giftType}||${coupon.giftAmount}`,
    };

    axios
      .patch(server + "/user/users/me", content, {
        headers: { authorization: jwt },
      })
      .then(({ status }) => {
        // console.log(status);
        setUserData({
          ...userData,
          ...content,
        });
        localStorage.removeItem("done");
        history.push("/token/" + token + "/finished");
      })
      .catch((e) => {
        console.log(e);
        history.push("/noToken");
      });
  };

  const submit = () => {
    if (!coupon.giftType || (doneState === "신청" && phoneNumber === "")) {
      const listMsg =
        (coupon.giftType ? "" : "쿠폰, ") +
        (phoneNumber !== "" ? "" : "전화번호, ");

      Swal.fire({
        confirmButtonText: "닫기",
        confirmButtonColor: "#00aeef",
        text:
          listMsg.substring(0, listMsg.length - 2) +
          (phoneNumber !== "" ? "을 선택해주세요." : "를 입력해주세요."),
        heightAuto: false,
      });
    } else if (phoneNumber !== "" && !isValidPhone(phoneNumber)) {
      Swal.fire({
        confirmButtonText: "닫기",
        confirmButtonColor: "#00aeef",
        text: "전화번호가 잘못 입력되었습니다. 확인 부탁드립니다.",
        heightAuto: false,
      });
    } else {
      if (doneState === "신청") {
        Swal.fire({
          confirmButtonText: "전화번호 제출하기",
          confirmButtonColor: "#00aeef",
          showCancelButton: true,
          cancelButtonText: "취소하기",
          cancelButtonColor: "#d33",
          title: "확인해 주세요!",
          text: phoneNumber + "가 본인의 전화번호가 맞나요?",
          heightAuto: false,
        }).then((result) => {
          if (result.isConfirmed) {
            patchCoupon();
          }
        });
      } else {
        patchCoupon();
      }
    }
  };

  const markNumber = (number) => {
    const str = String(number);
    if (str.length > 3) {
      var result = str.substring(str.length - 3, str.length);
      for (var i = str.length - 3; i > 0; i -= 3) {
        result = str.substring(i - 3, i) + "," + result;
      }
      return result;
    } else {
      return str;
    }
  };

  useEffect(() => {
    const savedDone = JSON.parse(localStorage.getItem("done"));
    if (savedDone) {
      setCoupon(savedDone.coupon || "");
      setPhoneNumber(savedDone.contact || "");
    } else if (userData.gift) {
      const delimGift = userData.gift.split("||");
      setCoupon({ giftType: delimGift[0], giftAmount: parseInt(delimGift[1]) });
      setPhoneNumber(userData.giftContact || "");
    } else {
      setCoupon(userData.gov.giftList[0]);
    }
    setDoneState(location.state || "신청");
    if (couponList.length === 1) setCoupon(couponList[0]);

    const saved = localStorage.getItem("feedback");
    if (saved) {
      setFeedbackText(saved ? saved : "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    localStorage.setItem(
      "done",
      JSON.stringify({
        coupon,
        contact: phoneNumber,
      })
    );
  }, [coupon, phoneNumber]);

  useEffect(() => {
    localStorage.setItem("feedback", feedbackText);
  }, [feedbackText]);

  return (
    <div className="container" id="done__container">
      <div className="logo" id="done__logo">
        <img src={userData.gov.logoUrl} alt="state logo" />
      </div>
      {
        <div className="wrap" id="done__wrap">
          <div className="title" id="done__title">
            <div id="done__title-two">
              <div className="icon">
                <img src={files + "/smileEmoji.svg"} alt="smile emoji" />
              </div>
              <h3>
                {couponList.length !== 1 ? (
                  <p>
                    아래의 선물 중 <br className="pc-hide" />
                    하나를 선택해주세요 :)
                  </p>
                ) : (
                  <p>
                    {doneState === "신청" && (
                      <>
                        조사기간이 종료된 후에
                        <br />
                        답례품을 보내드려요
                      </>
                    )}
                    {doneState === "기부" && (
                      <>아래의 답례품이 기부될 예정입니다.</>
                    )}

                    {doneState === "미신청" && (
                      <>
                        <h3
                          style={{
                            display: "block",
                            paddingBottom: 5,
                            color: "black",
                          }}
                        >
                          다시 한 번 <br /> 귀중한 의견참여에 감사드립니다.
                          <br />
                        </h3>
                        <span
                          style={{
                            color: "#989898",
                            fontSize: 16,
                            lineHeight: "24px",
                            display: "block",
                          }}
                        >
                          참여하신 분의 전화번호를 남겨주시면 <br />
                          활동의 결과와 후속 활동에 대한 안내를 알려드립니다.
                          <br />
                          앞으로도 많은 관심 부탁드립니다.
                        </span>
                      </>
                    )}
                  </p>
                )}
              </h3>
            </div>
          </div>
          {doneState !== "미신청" && (
            <div className="table" id="done__table">
              {couponList.map((gift, idx) => (
                <Fragment key={idx}>
                  <input
                    id={"coupon" + idx}
                    type="radio"
                    name="coupon"
                    value={idx}
                    onChange={(e) => setCoupon(couponList[e.target.value])}
                    checked={
                      coupon.giftType === couponList[idx].giftType &&
                      coupon.giftAmount === couponList[idx].giftAmount
                    }
                  />
                  <label
                    className="coupon"
                    htmlFor={"coupon" + idx}
                    alt={gift.giftType + " " + gift.giftAmount + "원"}
                  >
                    <div className="coupon-label">
                      <Label number={idx + 1} />
                    </div>
                    <div className="coupon-detail">
                      <p className="coupon-name">{gift.giftType}</p>
                      <p className="coupon-price">
                        {markNumber(gift.giftAmount)}원
                      </p>
                    </div>
                    <div className="check">
                      <div className="icon">
                        <CheckIcon />
                      </div>
                    </div>
                  </label>
                </Fragment>
              ))}
            </div>
          )}
          <div
            className="content"
            id="done__content"
            style={{ marginTop: doneState === "미신청" ? 50 : 0 }}
          >
            <div className="phone-number">
              {doneState === "기부" && <>기부하신 분의 전화번호를 입력하세요</>}
              {doneState === "신청" && (
                <>답례품을 받을 전화번호를 입력해주세요</>
              )}
              {doneState === "미신청" && (
                <>참가하신 분의 전화번호를 남겨주세요.</>
              )}
              <div className="red-dot"></div>
              <input
                type="text"
                placeholder="전화번호"
                onChange={(e) => inputPhoneNumber(e.target.value)}
                value={phoneNumber}
              ></input>
            </div>

            <div className="content-text">
              {doneState === "신청" && (
                <p>
                  {coupon.giftType
                    ? `${coupon.giftType} (${markNumber(
                        coupon.giftAmount
                      )}원) 을(를) 입력하신 번호로 발송해드립니다. `
                    : ""}
                  번호를 잘못 기입해서 못 받는 경우가 가끔 있습니다. 작성 후{" "}
                  <u className="bold black">
                    전화번호가 제대로 작성되었는지 다시 한 번 확인
                  </u>{" "}
                  부탁드립니다.
                </p>
              )}
              {doneState === "기부" && (
                <p>
                  남겨주신 전화번호로 후속 활동에 대한 안내와 기부 결과를
                  알려드립니다. 다시 한 번 귀중한 의견 참여에 감사드리며
                  앞으로도 많은 관심 부탁드립니다.
                </p>
              )}
            </div>
          </div>
        </div>
      }
      <div className="link-buttons">
        <div className="link-btns-inner">
          <Link
            to={"/token/" + token + "/success"}
            className="link-btn"
            alt="뒤로 버튼"
          >
            뒤로
          </Link>
          <button onClick={submit} className="link-btn btn" alt="제출하기 버튼">
            제출하기
          </button>
        </div>
      </div>
    </div>
  );
};

export default Done;
